{
  "de": {
    "task": {
      "actions": {
        "create": "Aufgabe",
        "create_and_send": "Erstellen und senden",
        "delete": "Aufgabe löschen",
        "keep_as_draft": "Als Entwurf behalten",
        "open_in_project": "Aufgabe im Projekt öffnen",
        "remove_from_unit": "Aufgabe von dieser Einheit entfernen",
        "save_as_draft": "Als Entwurf speichern",
        "update": "Aufgabe bearbeiten"
      },
      "attributes": {
        "assignments_count": "Zuweisungen",
        "category": "Art des Abschlusses",
        "created_at": "Erstellt",
        "description": "Beschreibung",
        "phase": "Phase",
        "title": "Titel"
      },
      "categories": {
        "confirmation": "Bestätigung",
        "upload": "Dokument hochladen"
      },
      "categories_info": {
        "confirmation": "Die verantwortliche Person hakt sie ab, sobald sie erledigt ist.",
        "upload": "Die verantwortliche Person muss eine Datei hochladen, um sie abzuschließen."
      },
      "confirm": {
        "delete_accept": "Überall löschen",
        "delete_body": "Das löscht {count} Aufgabe über {units}, auch wenn sie schon erledigt ist. | Das löscht alle {count} Aufgaben über {units}, auch die bereits erledigten.",
        "delete_body_empty": "Das löscht die Aufgabe.",
        "delete_body_project": "Das löscht die Aufgabe und ihre verantwortliche Person. | Das löscht die Aufgabe und alle {count} verantwortlichen Personen.",
        "delete_cancel": "Aufgabe behalten",
        "delete_header": "„{title}“ löschen?",
        "delete_silent": "Niemand wird benachrichtigt, und bereits versendete Benachrichtigungen werden nicht zurückgenommen.",
        "publish_body": "Wir erstellen {tasks} für {units} und senden sie an die Verantwortlichen. Jede Aufgabe steht auf Offen, bis sie erledigt ist.",
        "publish_body_project": "Wir erstellen {tasks} in diesem Projekt und senden sie an die Verantwortlichen. Jede Aufgabe steht auf Offen, bis sie erledigt ist.",
        "publish_header": "Diese Aufgabe erstellen und senden?",
        "publish_info": "Die Verantwortlichen erhalten sofort eine E-Mail. Speichere als Entwurf, wenn du noch nicht bereit bist, sie zu senden.",
        "remove_from_unit_accept": "Aus Einheit entfernen",
        "remove_from_unit_body": "Das entfernt alle verantwortlichen Personen dieser Aufgabe in dieser Einheit. Die Aufgabe und ihre anderen Einheiten bleiben unberührt.",
        "remove_from_unit_customers": "Kunden dieser Einheit sehen sie nicht mehr in ihrem Portal.",
        "remove_from_unit_header": "„{title}“ aus dieser Einheit entfernen?"
      },
      "deep_link": {
        "show_all": "Alle Aufgaben anzeigen",
        "single": "Sie sehen eine Aufgabe."
      },
      "empty": {
        "filtered_description": "Mit den gewählten Filtern wurde nichts gefunden. Lösche sie, um alle Aufgaben zu sehen.",
        "filtered_description_project": "Mit den gewählten Filtern wurde nichts gefunden. Lösche sie, um alle Aufgaben in diesem Projekt zu sehen.",
        "filtered_title": "Keine Aufgaben passen zu deinen Filtern",
        "none_description": "Erstelle eine Aufgabe und weise sie deinem Team oder den Kunden einer oder mehrerer Einheiten zu. Sie erscheint hier, sobald du sie versendest.",
        "none_description_sup": "Erstelle eine Aufgabe und weise sie deinem Team oder deinen Kunden zu. Sie erscheint hier, sobald du sie versendest.",
        "none_title": "Noch keine Aufgaben"
      },
      "filters": {
        "phase_none": "Keine Phase",
        "search": "Aufgabe suchen"
      },
      "form": {
        "category_subtitle": "Lege fest, wie die verantwortliche Person die Aufgabe als erledigt markiert",
        "category_title": "Wie wird sie abgeschlossen?",
        "description_help": "Sichtbar für alle, die diese Aufgabe erhalten.",
        "description_placeholder": "Füge Details oder Anweisungen hinzu",
        "edit_info_assignments": "Verantwortliche, Einheiten und Fristen verwaltest du pro verantwortliche Person in der Aufgabenliste.",
        "edit_info_assignments_project": "Verantwortliche und Fristen verwaltest du pro verantwortliche Person in der Aufgabenliste.",
        "edit_info_fields": "Titel und Beschreibung passt du hier an.",
        "edit_info_fields_phase": "Titel, Beschreibung und Phase passt du hier an.",
        "heading_create": "Neue Aufgabe",
        "heading_update": "Aufgabe bearbeiten",
        "phase_help_create": "Verknüpft diese Aufgabe mit einer Phase im Workflow. Die Phase ist erst abgeschlossen, wenn jede Aufgabe darunter erledigt ist.",
        "phase_help_update": "Jede Einheit, die die neue Phase erreicht oder schon hinter sich hat, sieht diese Aufgabe sofort. Einheiten, die noch nicht so weit sind, sehen sie, sobald sie dort ankommen.",
        "phase_help_update_project": "Hat dieses Projekt die neue Phase erreicht oder schon hinter sich, sehen die Verantwortlichen diese Aufgabe sofort. Sonst sehen sie sie, sobald das Projekt dort ankommt.",
        "scope_headline": "{count} Aufgabe wird erstellt und gesendet | {count} Aufgaben werden erstellt und gesendet",
        "scope_project": "{assignees} in diesem Projekt",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "Was muss passieren?",
        "units_selected": "{selected} von {count} Einheit ausgewählt | {selected} von {count} Einheiten ausgewählt",
        "units_title": "Welche Einheiten"
      },
      "labels": {
        "assignees_count": "{count} verantwortliche Person | {count} verantwortliche Personen",
        "created_by": "Erstellt von {name} · {date}",
        "created_on": "Erstellt am {date}",
        "required": "Dieses Feld ist erforderlich",
        "set_all_assignees": "Für die verantwortliche Person setzen | Für alle {count} Verantwortlichen setzen",
        "still_to_do": "Noch {count} offen",
        "tasks_count": "{count} Aufgabe | {count} Aufgaben",
        "units_count": "{count} Einheit | {count} Einheiten",
        "units_required": "Wählen Sie mindestens eine Einheit aus"
      },
      "toasts": {
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "remove_from_unit": "Aufgabe von dieser Einheit entfernt",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
